import { generateAutomationName } from "app/pages/activation/helpers/generateAutomationName";

export const CompetitorsDropdownKeys = {
    applyButton: generateAutomationName("home", ["alerts", "competitors", "button", "apply"]),
};
